import { Phone, AlertTriangle } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { SITE, TEL_HREF } from "@/siteConfig";

const PROBLEMS = [
  "Il cancello non si apre?",
  "La serranda è bloccata?",
  "L'automazione non funziona?",
  "Hai un problema con una serratura o un accesso?",
];

export const UrgentProblems = () => (
  <section
    id="problemi-urgenti"
    data-testid="urgent-problems-section"
    className="scroll-mt-24 border-y border-white/[0.06] bg-[#0D1119] py-20 sm:py-28"
  >
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeading
        overline="Emergenza adesso"
        title="Hai uno di questi problemi in questo momento?"
        align="center"
      />

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5">
        {PROBLEMS.map((problem, idx) => (
          <Reveal key={problem} delay={idx * 0.08}>
            <div
              data-testid={`urgent-problem-card-${idx + 1}`}
              className="flex h-full flex-col gap-4 rounded-2xl border border-amber-400/20 bg-gradient-to-b from-amber-400/[0.07] to-transparent p-6 transition-all duration-300 hover:border-amber-400/50"
            >
              <AlertTriangle className="h-5 w-5 text-amber-400" />
              <p className="font-display text-lg font-bold leading-snug text-zinc-100">
                {problem}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2} className="mt-12 text-center">
        <p className="mx-auto max-w-2xl text-base sm:text-lg text-zinc-300 leading-relaxed">
          Contattaci e descrivi il problema. Verificheremo la disponibilità del
          servizio nella tua zona.
        </p>
        <a
          href={TEL_HREF}
          data-testid="urgent-call-now-button"
          className="mt-7 inline-flex items-center gap-3 rounded-full bg-amber-400 px-9 py-4 text-base font-extrabold uppercase tracking-wide text-zinc-950 transition-all hover:bg-amber-300 hover:shadow-[0_0_44px_rgba(245,158,11,0.45)] active:scale-[0.98]"
        >
          <Phone className="h-5 w-5" />
          Chiama ora · {SITE.phoneDisplay}
        </a>
      </Reveal>
    </div>
  </section>
);
